import de, { type Translations } from './de'
import en from './en'
import nl from './nl'
import it from './it'
import fr from './fr'
import es from './es'
import ro from './ro'
import hr from './hr'
import tr from './tr'
import ar from './ar'
import uk from './uk'
import pl from './pl'
import ru from './ru'

export type { Translations }

export const TRANSLATIONS = { de, en, nl, it, fr, es, ro, hr, tr, ar, uk, pl, ru } satisfies Record<string, Translations>

export type Locale = keyof typeof TRANSLATIONS
